module.exports = __webpack_public_path__ + "media/openTopAwardList.638977fd.mp3";